import { useState, useEffect } from "react";

const COLOR = "#7b3dd5";
const SPY_COLOR = "#ff3355";

function CountdownBar({ seconds, total, color }) {
  const [left, setLeft] = useState(seconds);
  useEffect(() => {
    setLeft(seconds);
    const iv = setInterval(() => setLeft(p => Math.max(0, p - 1)), 1000);
    return () => clearInterval(iv);
  }, [seconds]);
  const pct = Math.min(100, (left / total) * 100);
  return (
    <div style={{ width: "100%", height: 8, background: "#ffffff15", borderRadius: 4, overflow: "hidden", margin: "8px 0" }}>
      <div style={{ width: `${pct}%`, height: "100%", background: color || COLOR, borderRadius: 4, transition: "width 1s linear" }} />
    </div>
  );
}

export default function SpyfallPlayer({
  screen,
  role,
  location,
  round,
  maxRounds,
  questions,
  others,
  asker,
  currentQ,
  locationHint,
  waitingMsg,
  voteOptions,
  alreadyVoted,
  myVote,
  guessOptions,
  guessEarly,
  result,
  canGuessEarly,
  earlyPressed,
  timerSeconds,
  playerName,
  onAsk,
  onAnswerDone,
  onVote,
  onEarlyGuess,
  onLocationGuess,
}) {
  const [selectedQ, setSelectedQ] = useState(null);
  const [selectedTarget, setSelectedTarget] = useState(null);

  useEffect(() => {
    if (screen === "choose_question") {
      setSelectedQ(null);
      setSelectedTarget(null);
    }
  }, [screen]);

  if (screen === "role") {
    if (role === "spy") {
      return (
        <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
          <div style={{ fontSize: "4rem" }}>🕵️</div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.8rem", color: SPY_COLOR, textShadow: "2px 2px 0 #000", marginTop: 8 }}>
            ТЫ ШПИОН!
          </div>
          <div style={{ background: "#1a0010", border: `3px solid ${SPY_COLOR}`, borderRadius: "1.25rem", padding: "1rem 1.25rem", marginTop: "1.25rem" }}>
            <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.9rem", color: "#ff8080", lineHeight: 1.5 }}>
              Угадай локацию по ответам других игроков.<br />
              Не раскрывайся — задавай вопросы уверенно!
            </div>
          </div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.9rem", color: "#888", marginTop: "1rem" }}>
            Раунд {round}/{maxRounds}
          </div>
        </div>
      );
    }
    return (
      <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
        <div style={{ fontSize: "3rem" }}>{location?.emoji}</div>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.6rem", color: "#fff", textShadow: "2px 2px 0 #000", marginTop: 8 }}>
          {location?.name}
        </div>
        <div style={{ background: "#0d1a35", border: `2.5px solid ${COLOR}`, borderRadius: "1.25rem", padding: "0.85rem 1rem", marginTop: "1rem" }}>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#aaa", lineHeight: 1.5 }}>
            {location?.description}
          </div>
        </div>
        <div style={{ background: "#1a1a00", border: "2px solid #ffe600", borderRadius: "0.75rem", padding: "0.6rem 1rem", marginTop: "0.85rem" }}>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.75rem", color: "#ffe600" }}>
            🙅 Не показывай экран шпиону!
          </div>
        </div>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.9rem", color: "#888", marginTop: "0.75rem" }}>
          Раунд {round}/{maxRounds}
        </div>
      </div>
    );
  }

  if (screen === "choose_question") {
    return (
      <div style={{ padding: "1rem" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", color: "#ffe600", textAlign: "center", marginBottom: "1rem" }}>
          Твой ход! Выбери вопрос:
        </div>
        {(questions || []).map((q, i) => (
          <button key={i} onClick={() => setSelectedQ(q)} style={{
            display: "block", width: "100%", textAlign: "left",
            background: selectedQ === q ? `${COLOR}33` : "#ffffff08",
            border: `2px solid ${selectedQ === q ? COLOR : "#ffffff20"}`,
            borderRadius: "0.85rem", padding: "0.75rem 1rem", marginBottom: 8,
            fontFamily: "'Nunito',sans-serif", fontSize: "0.9rem", color: "#fff", cursor: "pointer",
          }}>
            {selectedQ === q ? "✓ " : ""}{q}
          </button>
        ))}
        {selectedQ && (
          <>
            <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem", color: "#aaa", margin: "1rem 0 0.5rem", textAlign: "center" }}>
              Кому задать?
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
              {(others || []).map(p => (
                <button key={p} onClick={() => setSelectedTarget(p)} style={{
                  background: selectedTarget === p ? `${COLOR}44` : "#ffffff10",
                  border: `2px solid ${selectedTarget === p ? COLOR : "#ffffff20"}`,
                  borderRadius: "0.75rem", padding: "0.5rem 1rem",
                  fontFamily: "'Fredoka One',sans-serif", fontSize: "0.95rem", color: "#fff", cursor: "pointer",
                }}>
                  {selectedTarget === p ? "✓ " : ""}{p}
                </button>
              ))}
            </div>
          </>
        )}
        {selectedQ && selectedTarget && (
          <button onClick={() => onAsk(selectedQ, selectedTarget)} style={{
            display: "block", width: "100%", marginTop: "1.25rem",
            background: COLOR, border: "3px solid #000", borderRadius: "1rem",
            padding: "0.85rem", fontFamily: "'Fredoka One',sans-serif",
            fontSize: "1.1rem", color: "#fff", cursor: "pointer", boxShadow: "4px 4px 0 #000",
          }}>
            Задать вопрос →
          </button>
        )}
      </div>
    );
  }

  if (screen === "answer_prompt") {
    return (
      <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem", color: "#aaa", marginBottom: 8 }}>
          {asker} спрашивает тебя:
        </div>
        <div style={{ background: "#0d0820", border: `3px solid ${COLOR}`, borderRadius: "1.25rem", padding: "1.25rem", fontFamily: "'Fredoka One',sans-serif", fontSize: "1.3rem", color: "#fff", textShadow: "1px 1px 0 #000", marginBottom: "1rem" }}>
          «{currentQ}»
        </div>
        {locationHint && (
          <div style={{ background: "#001a35", border: "2px solid #00c9ff55", borderRadius: "0.85rem", padding: "0.75rem 1rem", marginBottom: "1rem" }}>
            <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.8rem", color: "#00c9ff", marginBottom: 4 }}>
              Подсказка (только тебе):
            </div>
            <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.8rem", color: "#aaa" }}>{locationHint}</div>
          </div>
        )}
        <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#888", marginBottom: "1rem" }}>
          Ответь вслух всем игрокам
        </div>
        <CountdownBar seconds={timerSeconds} total={20} color={COLOR} />
        <button onClick={onAnswerDone} style={{
          display: "block", width: "100%", marginTop: "1rem",
          background: "#3dffa0", border: "3px solid #000", borderRadius: "1rem",
          padding: "0.85rem", fontFamily: "'Fredoka One',sans-serif",
          fontSize: "1.1rem", color: "#000", cursor: "pointer", boxShadow: "4px 4px 0 #000",
        }}>
          ✓ Ответил
        </button>
      </div>
    );
  }

  if (screen === "discussion") {
    return (
      <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
        <div style={{ fontSize: "2.5rem" }}>🕵️</div>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.3rem", color: SPY_COLOR, marginTop: 8 }}>
          Время обсуждения
        </div>
        <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#aaa", marginTop: 8, lineHeight: 1.5 }}>
          Если ты уже знаешь локацию — назови её досрочно и получи +300 очков!
        </div>
        {canGuessEarly && !earlyPressed && (
          <button onClick={onEarlyGuess} style={{
            display: "block", width: "100%", marginTop: "1.5rem",
            background: SPY_COLOR, border: "3px solid #000", borderRadius: "1rem",
            padding: "0.85rem", fontFamily: "'Fredoka One',sans-serif",
            fontSize: "1.1rem", color: "#fff", cursor: "pointer", boxShadow: "4px 4px 0 #000",
          }}>
            🎯 Я знаю где я!
          </button>
        )}
        {earlyPressed && (
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#888", marginTop: "1.5rem" }}>
            Ожидаем...
          </div>
        )}
      </div>
    );
  }

  if (screen === "vote") {
    return (
      <div style={{ padding: "1rem" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.2rem", color: "#fff", textAlign: "center", marginBottom: "1rem" }}>
          🗳️ Кто шпион?
        </div>
        {(voteOptions || []).map(p => (
          <button key={p} onClick={() => !alreadyVoted && onVote(p)} disabled={alreadyVoted} style={{
            display: "block", width: "100%", textAlign: "left",
            background: myVote === p ? `${SPY_COLOR}33` : "#ffffff08",
            border: `2px solid ${myVote === p ? SPY_COLOR : "#ffffff20"}`,
            borderRadius: "0.85rem", padding: "0.75rem 1rem", marginBottom: 8,
            fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem", color: "#fff",
            cursor: alreadyVoted ? "default" : "pointer",
            opacity: alreadyVoted && myVote !== p ? 0.5 : 1,
          }}>
            {myVote === p ? "✓ " : ""}{p}
          </button>
        ))}
        {alreadyVoted && (
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.85rem", color: "#888", textAlign: "center", marginTop: 8 }}>
            Голос отдан! Ожидаем остальных...
          </div>
        )}
      </div>
    );
  }

  if (screen === "guess_location") {
    return (
      <div style={{ padding: "1rem" }}>
        <div style={{ textAlign: "center", marginBottom: "1rem" }}>
          <div style={{ fontSize: "2rem" }}>🕵️</div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.2rem", color: SPY_COLOR, marginTop: 4 }}>
            {guessEarly ? "Досрочная угадка! (+300)" : "Угадай локацию! (+200)"}
          </div>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.8rem", color: "#aaa", marginTop: 4 }}>
            {guessEarly ? "Ошибёшься — мирные получат очки" : "Не угадаешь — мирные получат очки"}
          </div>
        </div>
        <CountdownBar seconds={timerSeconds} total={20} color={SPY_COLOR} />
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: "0.75rem" }}>
          {(guessOptions || []).map(loc => (
            <button key={loc.id} onClick={() => onLocationGuess(loc.id)} style={{
              display: "flex", alignItems: "center", gap: "0.75rem",
              background: "#ffffff08", border: `2px solid ${SPY_COLOR}55`,
              borderRadius: "0.85rem", padding: "0.75rem 1rem",
              fontFamily: "'Fredoka One',sans-serif", fontSize: "1rem", color: "#fff",
              cursor: "pointer", textAlign: "left",
            }}>
              <span style={{ fontSize: "1.5rem" }}>{loc.emoji}</span>
              <span>{loc.name}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  if (screen === "result" && result) {
    const { spy, location: loc, spy_caught, spy_guessed, scores } = result;
    const myScore = scores?.[playerName] || 0;
    const isSpy = playerName === spy;
    let msg, color;
    if (spy_caught) {
      msg = isSpy ? "Тебя поймали 😢" : "Шпион пойман! 🎉";
      color = isSpy ? SPY_COLOR : "#3dffa0";
    } else if (spy_guessed) {
      msg = isSpy ? "Ты угадал! 🎯" : "Шпион угадал локацию 😱";
      color = isSpy ? "#ffe600" : SPY_COLOR;
    } else {
      msg = isSpy ? "Не угадал..." : "Шпион не угадал! +150";
      color = isSpy ? "#888" : "#3dffa0";
    }
    return (
      <div style={{ textAlign: "center", padding: "1.5rem 1rem" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.5rem", color, marginBottom: 8 }}>{msg}</div>
        <div style={{ background: "#1a0535", border: `3px solid ${COLOR}55`, borderRadius: "1.25rem", padding: "1rem 1.25rem", display: "inline-block" }}>
          <div style={{ fontSize: "2rem" }}>{loc?.emoji}</div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.2rem", color: "#fff" }}>{loc?.name}</div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "0.8rem", color: "#888" }}>
            {isSpy ? "(ты был шпионом)" : `Шпион: ${spy}`}
          </div>
        </div>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", color: "#ffe600", marginTop: "1rem" }}>
          Твои очки: {myScore}
        </div>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
      <div style={{ fontSize: "2rem" }}>🕵️</div>
      <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: "0.9rem", color: "#888", marginTop: 8 }}>
        {screen === "waiting_msg" ? waitingMsg : "Ожидание хоста..."}
      </div>
    </div>
  );
}